import clsx from "clsx";
import React, {ReactNode} from "react";

interface Props {
    layout?: "row" | "col",
    className?: string,
    children?: ReactNode,
}

const FormGroup: React.FC<Props> = (
    {
        layout = "col",
        className = null,
        children = '',
    }
) => {
    return (
        <div className={clsx(
            `flex gap-2`,
            {
                "flex-col": layout === "col",
                "flex-row items-center": layout === "row",
            },
            className
        )}>
            { children }
        </div>
    );
}

export default FormGroup;